// TODO (RUR-246): bump react-apply-now to get the updated values from https://github.com/NerdWallet/react-components/pull/2488/files
import { LinkType as LINK_TYPES } from '@nerdwallet/react-apply-now';
import MarketplaceCta from './marketplace-cta';
export default MarketplaceCta;
export { LINK_TYPES };